/**
 * A custom element that shows a random subset of its product list items,
 * persisted for the current browser session (same picks until the tab/browser session ends).
 */
class RandomFeaturedProducts extends HTMLElement {
  connectedCallback() {
    const items = Array.from(this.querySelectorAll('[data-product-id]'));
    if (items.length === 0) return;

    const count = parseInt(this.dataset.count, 10) || 4;
    const storageKey = 'og-drawer-featured-products';

    let chosenIds = null;
    try {
      const stored = sessionStorage.getItem(storageKey);
      chosenIds = stored ? JSON.parse(stored) : null;
    } catch (error) {
      chosenIds = null;
    }

    const availableIds = items.map((item) => item.dataset.productId);
    const isStoredSelectionValid = Array.isArray(chosenIds) && chosenIds.every((id) => availableIds.includes(id));

    if (!isStoredSelectionValid) {
      chosenIds = [...items]
        .sort(() => Math.random() - 0.5)
        .slice(0, count)
        .map((item) => item.dataset.productId);

      try {
        sessionStorage.setItem(storageKey, JSON.stringify(chosenIds));
      } catch (error) {
        // sessionStorage unavailable (e.g. private browsing) - selection just won't persist across page loads
      }
    }

    items.forEach((item) => {
      item.hidden = !chosenIds.includes(item.dataset.productId);
    });
  }
}

if (!customElements.get('random-featured-products')) {
  customElements.define('random-featured-products', RandomFeaturedProducts);
}
